module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_0@3x.0ffede39.png";